import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Loader2, ShieldAlert } from 'lucide-react'

// Port pixel-identik dari V1 app/login/page.tsx.
// Perubahan hanya: useSearchParams (react-router), signIn → redirect ke /auth/google, Image → img.
export default function Login() {
  const [params] = useSearchParams()
  const error = params.get('error')
  const [loading, setLoading] = useState(false)

  return (
    <div className="fixed inset-0 z-50 bg-[#F5F4F0] flex items-center justify-center p-6">
      {/* Texture */}
      <div className="absolute inset-0 opacity-[0.4] pointer-events-none"
        style={{ backgroundImage: 'radial-gradient(#E2E0D8 0.8px, transparent 0.8px)', backgroundSize: '22px 22px' }} />

      <div className="relative w-full max-w-[400px]">
        <div className="bg-white border border-[#E8E7E3] rounded-3xl shadow-2xl shadow-black/[0.06] p-8">
          {/* Brand */}
          <div className="flex flex-col items-center text-center mb-7">
            <div className="w-12 h-12 rounded-full overflow-hidden ring-1 ring-[#E0DFD8] mb-4">
              <img src="/logo.jpg" alt="Logo" width={48} height={48}
                className="w-full h-full object-cover" style={{ filter: 'invert(1)' }} />
            </div>
            <p className="text-[10px] uppercase tracking-[0.25em] text-[#C0BDB6] font-body mb-1.5">Sistem Internal</p>
            <h1 className="font-display text-3xl font-bold text-[#1A1916] leading-none">
              JAL <span className="text-[#6366F1]">Group</span>
            </h1>
            <p className="text-[13px] text-[#8A8A85] font-body mt-3 leading-relaxed">
              Masuk dengan akun Google yang sudah diundang untuk mengakses dashboard.
            </p>
          </div>

          {/* Error */}
          {error && (
            <div className="flex items-start gap-2.5 px-3.5 py-3 bg-[#FEF2F2] border border-[#FECACA] rounded-xl mb-5">
              <ShieldAlert className="w-4 h-4 text-[#DC2626] flex-shrink-0 mt-0.5" />
              <p className="text-xs text-[#DC2626] font-body leading-relaxed">
                {error === 'AccessDenied'
                  ? 'Akun ini belum terdaftar. Minta admin mengundang emailmu lebih dulu.'
                  : error === 'NotInvited'
                    ? 'Akun kamu belum terdaftar. Hubungi admin untuk di-invite terlebih dulu.'
                    : 'Login gagal. Coba lagi.'}
              </p>
            </div>
          )}

          {/* Google button */}
          <button
            onClick={() => {
              setLoading(true)
              sessionStorage.setItem('jal_play_intro', '1')
              window.location.href = '/auth/google'
            }}
            disabled={loading}
            className="w-full flex items-center justify-center gap-3 px-5 py-3 bg-white border border-[#E0DFD8] rounded-xl text-sm font-body font-semibold text-[#1A1916] hover:bg-[#FAFAF8] hover:border-[#C8C7BF] active:scale-[0.99] disabled:opacity-50 transition-all shadow-sm"
          >
            {loading ? (
              <Loader2 className="w-4 h-4 animate-spin" />
            ) : (
              <svg className="w-4 h-4" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" />
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
              </svg>
            )}
            Masuk dengan Google
          </button>

          <p className="text-[11px] text-[#C0BDB6] font-body text-center mt-5 leading-relaxed">
            Khusus akun yang sudah diundang admin. Domain email bebas.
          </p>
        </div>

        <p className="text-center text-[10px] text-[#C0BDB6] font-body mt-5">Internal Tool · JAL Group</p>
      </div>
    </div>
  )
}
